import http from "@/utils/request";

const brand = {
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderBrandService.queryVenderBrandList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createOrUpdate: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderBrandService.addOrUpdateVenderBrand",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  deleteBrands: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderBrandService.recoverVenderBrand",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  downloadBrandList: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderStockoutService.submitDownloadBrandTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default brand;
